var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "w-dialog",
    {
      staticClass: "pop-comment",
      attrs: {
        border: true,
        closeFree: "",
        width: "552px",
        top: "calc(50vh - 250px)",
        title: "发表评论",
      },
      on: { ok: _vm.onOk },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "评论内容", prop: "comments" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "64",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.comments,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "comments", $$v)
                  },
                  expression: "form.comments",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "附件", prop: "img" } },
            [
              _c("div", { staticClass: "tips" }, [
                _vm._v("（大小限制在4M以内，格式支持jpg，png）"),
              ]),
              _c("imageUpload", {
                attrs: { imgList: _vm.imgList, maxSize: 4 },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }